import { combineReducers, configureStore, createAction } from '@reduxjs/toolkit';

import { childNotebookSlice } from './domain/childNotebook/redux';
import { mealSlice } from './domain/meal/redux';
import { paymentSlice } from './domain/payment/redux';
import { privateBlogSlice } from './domain/privateBlog/redux';

import { attendContactSlice } from '@/domain/attendContact/redux';
import { attendRegisterSlice } from '@/domain/attendRegister/redux';
import { childSlice } from '@/domain/child/redux';
import { childApplySlice } from '@/domain/childApply/redux';
import { classSlice } from '@/domain/class/redux';
import { defecationSlice } from '@/domain/defecation/redux';
import { drugSlice } from '@/domain/drug/redux';
import { measureSlice } from '@/domain/measure/redux';
import { milkSlice } from '@/domain/milk/redux';
import { newsSlice } from '@/domain/news/redux';
import { noticeSlice } from '@/domain/notice/redux';
import { photoSlice } from '@/domain/photo/redux';
import { sleepSlice } from '@/domain/sleep/redux';
import { temperatureSlice } from '@/domain/temperature/redux';
import { uiSlice } from '@/domain/ui/redux';
import { userSlice } from '@/domain/user/redux';

const appReducer = combineReducers({
  /** UI */
  ui: uiSlice.reducer,
  /** ユーザー */
  user: userSlice.reducer,
  /** 子ども */
  child: childSlice.reducer,
  /** 申請 */
  childApply: childApplySlice.reducer,
  /** 連絡帳 */
  childNotebook: childNotebookSlice.reducer,
  /** クラス */
  class: classSlice.reducer,
  /** 出席連絡 */
  attendContact: attendContactSlice.reducer,
  /** 出席登録 */
  attendRegister: attendRegisterSlice.reducer,
  /** 内部ブログ */
  privateBlog: privateBlogSlice.reducer,
  /** お知らせ */
  news: newsSlice.reducer,
  /** 掲示板 */
  notice: noticeSlice.reducer,
  /** 身体測定 */
  measure: measureSlice.reducer,
  /** 支払い */
  payment: paymentSlice.reducer,
  /** 写真 */
  photo: photoSlice.reducer,
  /** 体温測定 */
  temperature: temperatureSlice.reducer,
  /** 排泄 */
  defecation: defecationSlice.reducer,
  /** ミルク */
  milk: milkSlice.reducer,
  /** 睡眠 */
  sleep: sleepSlice.reducer,
  /** 食事 */
  meal: mealSlice.reducer,
  /** 薬 */
  drug: drugSlice.reducer,
});

export const resetStore = createAction('store/reset');

const rootReducer: typeof appReducer = (state, action) => {
  if (resetStore.match(action)) {
    const resetState = appReducer(undefined, action);
    if (!state) {
      return resetState;
    }
    return {
      ...resetState,
      ui: {
        ...resetState.ui,
        countAction: state.ui.countAction,
      },
    };
  }
  return appReducer(state, action);
};

/**
 * Create Store
 * @returns CreateStore.
 */
export const createStore = () => configureStore({
  reducer: rootReducer,
});

/**
 * Store
 */
export const store = createStore();

/**
 * RootState
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * AppDispatch
 */
export type AppDispatch = typeof store.dispatch;

/**
 * ThunkApiType
 */
export type ThunkApiType = {
  /** dispatch */
  dispatch: AppDispatch,
  /** ステート */
  state: RootState,
};

/**
 * () => void の型
 */
export type voidFunctionType = () => void;
